// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchManufacturer {
constructor({
        id = null,
        name = '',
        dutyParagraph = '',
        address = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.dutyParagraph = dutyParagraph;
    this.address = address;
    this.description = description;
}
}

function newEntity() {
return new EmArchManufacturer();
}

function gridFields() {
return Object.freeze([
        {
        key: 'name',
        label: 'label.em.archive.emArchManufacturer.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'address',
        label: 'label.em.archive.emArchManufacturer.grid.address',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dutyParagraph',
        label: 'label.em.archive.emArchManufacturer.grid.dutyParagraph',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.archive.emArchManufacturer.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    nameFilter : "",
    addressFilter : "",
    dutyParagraphFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.archive.emArchManufacturer.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'addressFilter',
        label: 'label.em.archive.emArchManufacturer.filter.address',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dutyParagraphFilter',
        label: 'label.em.archive.emArchManufacturer.filter.dutyParagraph',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.archive.emArchManufacturer.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'dutyParagraph',
        label: 'label.em.archive.emArchManufacturer.entity.dutyParagraph',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'address',
        label: 'label.em.archive.emArchManufacturer.entity.address',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'description',
        label: 'label.em.archive.emArchManufacturer.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmArchManufacturer, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
